import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../shared/interface/user-permissions";
import {Uuid} from "../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";
import {PartnerService} from "../../shared/services/partner.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {take} from "rxjs/operators";
import {Ofwca} from "../../shared/interface/ofwca";
import {OfwcaService} from "../../shared/services/ofwca.service";
import {ContractService} from "../../shared/services/contract.service";
import {RegistrationService} from "../../shared/services/registration.service";
import {IdentifierService} from "../../shared/services/identifier.service";
import {CommissionImportRowService} from "../../shared/services/commission-import-row.service";
import {co} from "@fullcalendar/core/internal-common";
import {AuthService} from "../../shared/services/auth.service";

 interface DialogData {
  filter: any;
  reportName: any;
   sortBy: any;
   sortOrder: any;
}
interface Headers {
  reportName: any;
  value: string[][];
  blockValue?: string[][];
}
@Component({
  selector: 'app-report-custom',
  templateUrl: './report-custom.component.html',
  styleUrls: ['./report-custom.component.scss']
})
export class ReportCustomComponent implements OnInit {
  selectedValues = [];
  reportCustomForm: FormGroup;
  activeHeaders: string[][];
  blockHeaders: string[][];
  isAdmin = false;

  adminHeaders: string[][] = [
    ['Blokada wysyłki rozliczenia ASF', 'Blokada generowania faktur ASF', 'Blokada komornicza ASF'],
    ['Blokada wysyłki rozliczenia ASF Premium', 'Blokada generowania faktur ASF Premium', 'Blokada komornicza ASF Premium']
  ];

  basicPartnerHeaders: string[][] = [
    ['ID', 'Excel ID', 'Numer Profitowi', 'Pełna nazwa' ],
    ['Skrócona nazwa', 'Forma prawna' , 'Typ działalności' , 'Reprezentacja'],
    ['NIP', 'REGON', 'KRS', 'Ulica siedziby'],
    ['Nr budynku siedziby', 'Nr mieszkania siedziby', 'Poczta siedziby', 'Kod pocztowy siedziby'],
    ['Województwo siedziby', 'Miejscowość siedziby', 'Powiat siedziby', 'Gmina siedziby'],
    ['Ulica koresp.', 'Nr budynku koresp.' , 'Nr mieszkania koresp.', 'Poczta koresp.'],
    ['Kod pocztowy koresp.', 'Województwo adr. koresp.', 'Miejscowość koresp.' , 'Powiat koresp.'],
    ['Gmina koresp.' , 'Email', 'Email rozliczeniowy', 'Email marketingowy'],
    ['Telefon', 'Telefon rozliczeniowy', 'Telefon marketingowy', 'Regionalny (majątek) Partnera'],
    ['Regionalny (życie)', 'Numer konta', 'Zarejestrowany jako płatnik VAT', 'Status'],
    ['Właściciel (OFWCA)', 'Regionalni (majątek) OFWCA', 'VIP', 'Dobry Agent'],
    ['Profitowi', 'Placówka Własna', 'Agent wyłączny ASF', 'MultiOFWCA'],
    ['Agent z teczką', 'Terminal ASF', 'Komis samochodowy', 'Franczyza'],
    ['BRS' , 'LEAD', 'FOTO', 'Rekord zweryfikowany'],
    ['Uwagi', 'Data utworzenia', 'Czy jest partner nadrzędny', 'ID Partnera do analiz'],
    ['Nazwa Partnera do analiz', 'Hiperio Login', 'Hiperio Email', 'Wiadomości konkursowe'],
    ['Samofakturowanie ASF Grzegorz Adamczuk', 'Samofakturowanie ASF Premium', 'Nowy Partner' , "IDD konkursy"],
    ["Data zawieszenia działalności", "Data wznowienia działalności " , "Data rozpoczęcia działalności" , "Data zakończenia działalności "],
    [ "Weryfikacja procesu sprzedaży", 'Klub Agenta Premium', 'ID Użytkownika', 'Imię i Nazwisko Użytkownika'],
    ['Login ASF360', 'Partner Nadprowizja',  'Wiadomości produktowe']
  ];
  headers: Headers[] = [
    {
      reportName: 'partner',
      value: this.basicPartnerHeaders,
      blockValue: null
    },
    {
    reportName: 'partner_regional',
    value: [
      ['Pełna nazwa', 'Skrócona nazwa', 'NIP',  'REGON' ],
      ['Ulica siedziby', 'Nr budynku siedziby', 'Nr mieszkania siedziby', 'Kod pocztowy siedziby'],
      ['Województwo siedziby', 'Miejscowość siedziby', 'Powiat siedziby', 'Email' ],
      ['Email rozliczeniowy', 'Email marketingowy', 'Telefon', 'Status'],
      ['Nazwa Partnera do analiz', 'Nowy Partner', 'Partner Nadprowizja',  'Wiadomości produktowe']
    ],
      blockValue: [['ID', 'Excel ID', 'Numer Profitowi', 'Login ASF360'],
        [ 'Forma prawna' , 'Typ działalności' , 'Reprezentacja', 'KRS'],
        ['Ulica koresp.', 'Nr budynku koresp.' , 'Nr mieszkania koresp.', 'Poczta koresp.'],
        ['Kod pocztowy koresp.', 'Województwo adr. koresp.', 'Miejscowość koresp.' , 'Powiat koresp.'],
        ['Gmina koresp.', 'Telefon rozliczeniowy', 'Telefon marketingowy', 'Regionalny (majątek) Partnera'],
        ['Regionalny (życie)', 'Numer konta', 'Zarejestrowany jako płatnik VAT', 'Imię i Nazwisko Użytkownika'],
        ['Właściciel (OFWCA)', 'Regionalni (majątek) OFWCA', 'VIP', 'Dobry Agent'],
        ['Profitowi', 'Placówka Własna', 'Agent wyłączny ASF', 'MultiOFWCA'],
        ['Agent z teczką', 'Terminal ASF', 'Komis samochodowy', 'Franczyza'],
        ['BRS' , 'LEAD', 'FOTO', 'Rekord zweryfikowany'],
        ['Uwagi', 'Data utworzenia', 'Czy jest partner nadrzędny', 'ID Partnera do analiz'],
        ['Hiperio Login', 'Hiperio Email', 'Wiadomości konkursowe', 'ID Użytkownika'],
        ['Samofakturowanie ASF Grzegorz Adamczuk', 'Samofakturowanie ASF Premium', "IDD konkursy", 'Klub Agenta Premium'],
        ["Data zawieszenia działalności", "Data wznowienia działalności " , "Data rozpoczęcia działalności" , "Data zakończenia działalności "],
        [ "Weryfikacja procesu sprzedaży"],
      ]
  },
    {
    reportName: 'ofwca',
    value: [      ['ID', 'Excel ID', 'Numer Profitowi', 'Partner ID'],
  ['Partner Excel ID', 'Partner NIP', 'Imię', 'Drugie imię'],
  ['Nazwisko' , 'PESEL' , 'RAU', 'Login Chronie.pl' ],
  ['Login Hiperio', 'Email Hiperio' , 'Nazwisko rodowe' , 'Nazwisko panieńskie matki' ],
  ['Imię matki', 'Imię ojca' , 'Miejsce urodzenia' , 'Data urodzenia'],
  ['Płeć', 'Wykształcenie' , 'Typ dokumentu' , 'Organ wydający' ],
  ['Numer dokumentu' , 'Data wydania' , 'Data ważności' , 'Email' ],
  ['Email produktowy' , 'Email konkursowy' , 'Telefon', 'Telefon produktowy' ],
  ['Telefon marketingowy' , 'Zgoda na wiadomości produktowe' , 'Właściciel' , 'Partner Nadprowizja'],
  ['Zgoda na wiadomości konkursowe' , 'Ulica zameldowania' , 'Nr budynku zameldowania' , 'Nr mieszkania zameldowania' ],
  ['Poczta zameldowania' , 'Kod pocztowy zameldowania' , 'Województwo zameldowania' , 'Miejscowość zameldowania' ],
  ['Powiat zameldowania' , 'Gmina zameldowania' , 'Ulica zamieszkania' , 'Nr budynku zamieszkania' ],
  ['Nr mieszkania zamieszkania', 'Poczta zamieszkania' , 'Kod pocztowy zamieszkania' , 'Województwo zamieszkania'],
  ['Miejscowość zamieszkania' , 'Powiat zamieszkania' , 'Gmina zamieszkania' , 'Ulica koresp.' ],
  ['Nr budynku koresp.' , 'Nr mieszkania koresp.' , 'Poczta koresp.', 'Kod pocztowy koresp.'],
  ['Województwo adr. koresp.' , 'Miejscowość koresp.' , 'Powiat koresp.' , 'Gmina koresp.' ],
  ['Regionalny (majątek) OFWCA' , 'Regionalny (majątek) Partnera' , 'Regionalny (życie)' , 'Partner' ],
  ['Właściciel firmy' , 'Ulica placówki' , 'Nr budynku placówki' , 'Nr mieszkania placówki' ],
  ['Poczta placówki' , 'Kod pocztowy placówki' , 'Województwo placówki' , 'Miejscowość placówki' ],
  ['Powiat placówki' , 'Gmina placówki' , 'Status' , 'Rekord zweryfikowany' ],
  ['Uwagi' , 'Data utworzenia' , 'Czy jest partner nadrzędny' , 'ID Partnera do analiz' ],
  ['Nazwa Partnera do analiz' , 'Aktywna' , 'Pełny adres placówki', 'Hiperio (Nadanie dostępu)'],
  ['Automatyczna aktualizacja dostępów', 'Zablokowana', 'IDD konkursy']],
      blockValue: null
  },
    {
      reportName: 'ofwca_regional',
      value: [
        ['Imię', 'Nazwisko', 'RAU', 'Email produktowy'],
        ['Email konkursowy', 'Zgoda na wiadomości konkursowe', 'Zgoda na wiadomości produktowe', 'Partner'],
        ['Status', 'Nazwa Partnera do analiz', 'Pełny adres placówki', 'IDD konkursy'],
        ['Partner Nadprowizja', 'Właściciel']
      ],
      blockValue: [
        ['ID', 'Excel ID', 'Numer Profitowi', 'Partner ID'],
        ['Partner Excel ID', 'Partner NIP', 'Drugie imię', 'Login Chronie.pl' ],
        ['Login Hiperio', 'Email Hiperio' , 'Nazwisko rodowe' , 'Nazwisko panieńskie matki' ],
        ['Imię matki', 'Imię ojca' , 'Miejsce urodzenia' , 'Data urodzenia'],
        ['Płeć', 'Wykształcenie' , 'Typ dokumentu' , 'Organ wydający' ],
        ['Numer dokumentu' , 'Data wydania' , 'Data ważności' , 'Email' ],
        [ 'Ulica zameldowania' , 'Nr budynku zameldowania' , 'Nr mieszkania zameldowania' , 'PESEL'],
        ['Poczta zameldowania' , 'Kod pocztowy zameldowania' , 'Województwo zameldowania' , 'Miejscowość zameldowania' ],
        ['Powiat zameldowania' , 'Gmina zameldowania' , 'Ulica zamieszkania' , 'Nr budynku zamieszkania' ],
        ['Nr mieszkania zamieszkania', 'Poczta zamieszkania' , 'Kod pocztowy zamieszkania' , 'Województwo zamieszkania'],
        ['Miejscowość zamieszkania' , 'Powiat zamieszkania' , 'Gmina zamieszkania' , 'Ulica koresp.' ],
        ['Nr budynku koresp.' , 'Nr mieszkania koresp.' , 'Poczta koresp.', 'Kod pocztowy koresp.'],
        ['Województwo adr. koresp.' , 'Miejscowość koresp.' , 'Powiat koresp.' , 'Gmina koresp.' ],
        ['Regionalny (majątek) OFWCA' , 'Regionalny (majątek) Partnera' , 'Regionalny (życie)' , 'Telefon' ],
        ['Właściciel firmy' , 'Ulica placówki' , 'Nr budynku placówki' , 'Nr mieszkania placówki' ],
        ['Poczta placówki' , 'Kod pocztowy placówki' , 'Województwo placówki' , 'Miejscowość placówki' ],
        ['Powiat placówki' , 'Gmina placówki' ,  'Rekord zweryfikowany',  'Hiperio (Nadanie dostępu)' ],
        ['Uwagi' , 'Data utworzenia' , 'Czy jest partner nadrzędny' , 'ID Partnera do analiz' ],
        [ 'Aktywna' , 'Automatyczna aktualizacja dostępów', 'Zablokowana', 'Telefon produktowy'],
        [ 'Telefon marketingowy']
       ]
    }, {
    reportName: 'contract',
      blockValue: null,
    value: [     [ 'ID', 'Data zawarcia', 'Strona umowy', 'Partner/OFWCA'],
  ['Rodzaj', 'Status' , 'Powód rozwiązania' , 'Numer' ],
  ['Aktywna od', 'Data zakończenia', 'Okres wypowiedzenia' , 'Sposób rozwiązania' ],
  ['Czas trwania' , 'Firma' , 'Regionalny (majątek)' , 'VIP' ],
  ['Dobry Agent' , 'Profit' , 'Placówka Własna' , 'Agent wyłączny ASF' ],
  ['MultiOFWCA' , 'Agent z teczką', 'Terminal ASF' , 'Komis samochodowy' ],
  ['Franczyza' , 'BRS' , 'LEAD', 'FOTO' ],
  ['Rekord zweryfikowany' , 'Uwagi' , 'Powód anulowania' , 'Wyjaśnienie' ],
  ['Partner: NIP' , 'Partner: REGON' , 'Partner: KRS' , 'Partner: Ulica siedziby' ],
  ['Partner: Nr budynku siedziby' , 'Partner: Nr mieszkania siedziby' , 'Partner: Poczta siedziby', 'Partner: Kod pocztowy siedziby' ],
  ['Partner: Województwo siedziby' , 'Partner: Miejscowość siedziby' , 'Partner: Powiat siedziby' , 'Partner: Gmina siedziby' ],
  ['Partner: Ulica koresp.' , 'Partner: Nr budynku koresp.', 'Partner: Nr mieszkania koresp.' , 'Partner: Poczta koresp.' ],
  ['Partner: Kod pocztowy koresp.', 'Partner: Województwo adr. koresp.' , 'Partner: Miejscowość koresp.' , 'Partner: Powiat koresp.' ],
  ['Partner: Gmina koresp.', 'Partner: Email' , 'Partner: Email rozliczeniowy' , 'Partner: Email marketingowy' ],
  ['Partner: Telefon' , 'Partner: Telefon rozliczeniowy' , 'Partner: Telefon marketingowy' , 'Partner: ID' ],
  ['Czy jest partner nadrzędny' , 'ID Partnera do analiz' , 'Nazwa Partnera do analiz' , 'ID OFWCA'],
  ['Samofakturowanie adres email' , 'Samofakturowanie numer telefonu' , 'Samofakturowanie numer rachunku bankowego' ,
    'Zarejestrowany jako płatnik VAT' ],
  ['Płatnik VAT czynny' , 'Metoda Kasowa' , 'Nowy wzór umowy' , 'Stawki niestandardowe'],
      ['Automatyczne rozliczanie', 'Niestandardowe zapisy w umowie', 'Adres email umowa współpracy', 'Oczekuje']]
  }, {
      reportName: 'identifiers',
      blockValue: null,
      value: [  ['ID' , 'ID OFWCA', 'Excel ID OFWCA' , 'TU' ],
  ['OFWCA', 'PESEL' , 'RAU' , 'Rodzaj' ],
  ['Identyfikator' , 'Aktywny' , 'Rodzaj TU' , 'Status' ],
  ['Data dodania wniosku o rejestrację' , 'Oświadczenie komplet' , 'Brakujące oświadczenia' , 'Firma' ],
  ['Umowa', 'Partner' , 'ID Partner' , 'Excel ID Partner'],
  [ 'Regionalny (majątek)' , 'Regionalny (życie)', 'Podwójna rejestracja' , 'Jaki egzamin potrzebny'],
  ['Aktywne KRK' , 'Zaświadczenie 100p' , 'Zaświadczenie 40p', 'Dyplom'],
  ['Status upoważnienia' , 'Data wygenerowania upoważnienia' , 'NIP do rejestracji w Link 4', 'Zgoda na rejestrację w PZU'],
  ['Zgoda ASF na wyrejestrowanie' , 'Paczka' , 'Powód wyrejestrowania', 'Uwagi'],
  ['Data wyrobienia KRK' , 'Data ważności KRK' , 'Pozostało dni ważności KRK', 'VIP'],
  ['Dobry Agent' , 'Profitowi' , 'Placówka Własna', 'Agent wyłączny ASF'],
  ['MultiOFWCA' , 'Agent z teczką' , 'Terminal ASF', 'Komis samochodowy'],
  ['Franczyza' , 'Email produktowy', 'Email konkursowy', 'Zgoda na wiadomości produktowe'],
  ['Zgoda na wiadomości konkursowe' , 'Typ umowy', 'Czy jest partner nadrzędny', 'ID Partnera do analiz'],
  ['Nazwa Partnera do analiz' , 'Login Chronie.pl' , 'Login Hiperio' ]]
    },
    {
      reportName: 'identifiers_regional',
      value: [
        ['TU', 'OFWCA', 'RAU', 'Rodzaj' ],
        ['Identyfikator', 'Aktywny', 'Status', 'Zgoda na wiadomości konkursowe'],
        ['Partner', 'Firma',  'Email produktowy', 'Email konkursowy'],
        ['Zgoda na wiadomości produktowe', 'Nazwa Partnera do analiz', 'Login Chronie.pl',  'Login Hiperio' ],
        ['Email', 'Numer telefonu' ]
      ],
      blockValue: [  ['ID' , 'ID OFWCA', 'Excel ID OFWCA', 'Rodzaj TU' ],
        ['Data dodania wniosku o rejestrację' , 'Oświadczenie komplet' , 'Brakujące oświadczenia', 'PESEL'  ],
        ['Umowa',  'ID Partner' , 'Excel ID Partner',  'Komis samochodowy' ],
        [ 'Regionalny (majątek)' , 'Regionalny (życie)', 'Podwójna rejestracja' , 'Jaki egzamin potrzebny'],
        ['Aktywne KRK' , 'Zaświadczenie 100p' , 'Zaświadczenie 40p', 'Dyplom'],
        ['Status upoważnienia' , 'Data wygenerowania upoważnienia' , 'NIP do rejestracji w Link 4', 'Zgoda na rejestrację w PZU'],
        ['Zgoda ASF na wyrejestrowanie' , 'Paczka' , 'Powód wyrejestrowania', 'Uwagi'],
        ['Data wyrobienia KRK' , 'Data ważności KRK' , 'Pozostało dni ważności KRK', 'VIP'],
        ['Dobry Agent' , 'Profitowi' , 'Placówka Własna', 'Agent wyłączny ASF'],
        ['MultiOFWCA' , 'Agent z teczką' , 'Terminal ASF', 'Typ umowy'],
        ['Czy jest partner nadrzędny', 'ID Partnera do analiz' , 'Franczyza'  ]]
    }, {
    reportName: 'registration',
      blockValue: null,
    value: [  [ 'ID' , 'OFWCA' , 'TU' ],
      ['Profile sprzedażowe - Nazwa profilu', 'Profile sprzedażowe - Status' , 'Profile sprzedażowe - Data utworzenia'] ,
      ['Rodzaj TU', 'Status', 'Blokada sprzedaży - Wysłane do TU'],
      ['Blokada sprzedaży - Zablokowane', 'Data dodania wniosku o rejestrację' , 'Data wysłania do rejestracji do TU' ],
      ['Oświadczenie komplet', 'Brakujące oświadczenia' , 'Firma'],
      ['Umowa', 'Status umowy' , 'Partner'] ,
      ['Regionalny (majątek)' , 'Regionalny (życie)' , 'Podwójna rejestracja'],
      ['Jaki egzamin potrzebny' , 'PESEL' , 'Numer telefonu' ],
      ['Email' , 'Aktywne KRK' , 'Zaświadczenie 100p'],
      ['Zaświadczenie 40p', 'Data zmiany statusu KRK na "Zgłoszone"' , 'Dyplom' ],
      ['Kwestionariusz zgłoszeniowy PZU' , 'Status upoważnienia' , 'Data wygenerowania upoważnienia'],
      ['Biuro Compensa', 'NIP do rejestracji w Link 4' , 'Zgoda na rejestrację w PZU' ],
      ['Zgoda ASF na wyrejestrowanie' , 'Paczka' , 'Powód wyrejestrowania'],
      [ 'Uwagi' , 'Data wyrobienia KRK' , 'Data ważności KRK' ],
      ['Pozostało dni ważności KRK' , 'VIP', 'Dobry Agent'],
      [ 'Profitowi' , 'Placówka Własna' , 'Agent wyłączny ASF'],
      ['MultiOFWCA' , 'Agent z teczką' , 'Terminal ASF' ],
      ['Komis samochodowy' , 'Franczyza' ,  'Zgoda na wiadomości produktowe'],
      ['Zgoda na wiadomości konkursowe', 'Email produktowy', 'Email konkursowy'],
      ['RAU', 'Szkolenie wstępne' , 'Czy jest partner nadrzędny'] ,
      [ 'ID Partnera do analiz' , 'Nazwa Partnera do analiz' , 'Data zakończenia umowy' ],
      ['ID OFWCA' , 'Data zarejestrowania' , 'Status KRK' ],
      [ 'Wysłano do weryfikacji PZU', 'Adres do weryfikacji PZU kod pocztowy', 'Adres do weryfikacji PZU miasto'],
      ['Adres do weryfikacji PZU ulica', 'Adres do weryfikacji PZU numer domu', 'Adres do weryfikacji PZU numer lokalu'],
      ['Nazwa agencji do weryfikacji PZU', 'NIP do weryfikacji PZU', 'Segment do weryfikacji PZU'],
      ['Województwo placówki OFWCA', 'Unikatowy adres email' ,  'Pełny adres placówki OFWCA'],
      ['Adres placówki ulica', 'Adres placówki nr Budynku', 'Adres placówki nr lokalu'],
      ['Adres placówki Poczta', 'Adres placówki kod pocztowy' , 'Adres placówki miejscowość' ],
      ['Adres placówki województwo', 'Adres placówki powiat' , 'Adres placówki gmina'],
      ['Adres zamieszkania ulica', 'Adres zamieszkania nr Budynku', 'Adres zamieszkania nr lokalu'],
      ['Adres zamieszkania Poczta', 'Adres zamieszkania kod pocztowy' , 'Adres zamieszkania miejscowość'],
      ['Adres zamieszkania województwo', 'Adres zamieszkania powiat', 'Adres zamieszkania gmina'],
      ['Wykształcenie OFWCA', 'Płeć OFWCA', 'Dane do rejestracji Link4 Właściciel OFWCA'],
      ['Dane do rejestracji Link4 Nazwa firmy Partnera ', 'Dane do rejestracji Link4 email podstawowy Partnera', 'Data zapisania na egzamin'],
      ['Dostarczony wniosek o wykreślenie' , 'Data dostarczenia wniosku o wykreślenie', 'Wysłany wniosek o wykreślenie'],
      ['Data wysłania wniosku o wykreślenie', 'Zgoda na podwójną rejestrację', 'Data uzyskania zgody na podwójną rejestrację'],
      ['Aktualny podmiot rejestracji' , 'Uwagi - podwójna rejestracja', 'OFWCA Imię' ],
      ['OFWCA Drugie Imię' , 'OFWCA Nazwisko', 'Wpis w KNF'],
      ['Dodatkowy adres email', 'Dodatkowy nr telefonu']
    ],
  }, {
    reportName: 'commissions',
      blockValue: null,
    value: [  [ 'ID', 'OFWCA imię i nazwisko (z pliku)' , 'OFWCA' , 'Status OFWCA' ],
  ['PESEL' , 'RAU' , 'Kod zniżkowy Chronie.pl' , 'Typ identyfikatora' ],
  ['Identyfikator' , 'Rejestracja' , 'Status rejestracji' , 'Partner' ],
  ['Status Partnera' , 'Umowa' , 'Status umowy', 'Regionalny majątek (Partnera)' ],
  ['Regionalny życie (Partnera)' , 'Regionalny majątek (OFWCA)' , 'Placówka' , 'TU' ],
  ['Importer' , 'Firma' , 'Numer polisy' , 'Ryzyko ASF' ],
  ['Stawka % Partner' , 'Prowizja zł Partner' , 'Numer poprzedniej polisy' , 'Data zawarcia' ],
  ['Kod ryzyka', 'Riders' , 'Nazwa ryzyka' , 'Kod grupy' ],
  ['Inkaso' , 'Stawka % TU (z pliku)' , 'Prowizja zł' , 'Stawka % TU (wyliczona)'],
  ['Różnica Stawka % TU z pliku - wyliczona' , 'Data rozpoczęcia ochrony' , 'Data zakończenia ochrony' , 'Liczba rat' ],
  ['Typ polisy' , 'Status prowizji system' , 'Status z pliku' , 'Metoda płatności' ],
  ['Nazwa klienta' , 'PESEL klienta' , 'REGON klienta' , 'NIP klienta' ],
  ['Email klienta' , 'Telefon klienta' , 'Adres klienta' , 'Data importu' ],
  ['Uwagi' , 'Nazwa pośrednika' , 'Suma inkaso Proama' , 'Suma inkaso MTU komunikacja' ]]
  }];

  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  filtersForm: any;
  reportName: any;
  sortBy: any;
  sortOrder: any;
  service: any;
  reportNameControl: FormControl;
  headersControl: FormControl;
  constructor(
    private partnerService: PartnerService,
    private ofwcaService: OfwcaService,
    private contractService: ContractService,
    private registrationService: RegistrationService,
    private identifierService: IdentifierService,
    private commissionImportRowService: CommissionImportRowService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ReportCustomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private auth: AuthService
) {
    this.userPermissions = auth.getUserPermissions();
    this.filtersForm = data.filter;
    this.reportName = data.reportName;
    this.sortBy = data.sortBy;
    this.sortOrder = data.sortOrder;
    this.reportCustomForm = fb.group({
      headers: this.headersControl = fb.control([]),
      reportName: this.reportNameControl = fb.control([])
    });
  }


  ngOnInit(): void {
    switch (this.reportName) {
      case 'ofwca':
      case 'ofwca_regional':
        this.service = this.ofwcaService;
        break;
      case 'partner':
      case 'partner_regional':
        this.service = this.partnerService;
        break;
      case 'contract':
        this.service = this.contractService;
        break;
      case 'registration':
        this.service = this.registrationService;
        break;
      case 'identifiers':
      case 'identifiers_regional':
        this.service = this.identifierService;
        break;
      case 'commissions':
        this.service = this.commissionImportRowService;
        break;
    }

    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
        this.isAdmin = this.userPermissionss?.partner?.admin_root === true;

        this.headers.forEach((h: Headers) => {
          if (h.reportName === this.reportName) {
            this.activeHeaders = [...h.value];
            if (this.reportName === 'partner' && this.isAdmin) {
              this.activeHeaders = [
                ...this.activeHeaders,
                ...this.adminHeaders
              ];
            }
          if (h.blockValue) {
            this.blockHeaders = h.blockValue;
          }
        }
      });

        this.get();
      });
  }

  closeDialog(e): void {
    this.reportName.reset;
    this.filtersForm.reset;
    this.dialogRef.close(e);
  }
  isSelect(row?: string): boolean {
    let isSelect = false;
    this.selectedValues.forEach((h: string) => {
      if (row === h){
        isSelect = true;
      }
    });
    return isSelect;
  }
  save(): void {
    this.reportCustomForm.reset({
      headers: this.selectedValues.toString(),
      reportName: this.reportName
      }
    );
    this.service.sendCustomReportSettings(this.reportCustomForm.getRawValue())
      .pipe(take(1))
      .subscribe(() => {
        this.snack.open('Pomyślnie zapisano konfiguracje', '', {duration: 2000});
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy zapisywaniu konfiguracje  wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  add(header: string): void{
    if (this.selectedValues.indexOf(header) === -1) {
      this.selectedValues.push(header);
    }else{
      this.selectedValues.splice(this.selectedValues.indexOf(header),1);
    }
  }
  get(): void{
    this.service.getCustomReportSettings(this.reportName.toString())
    .subscribe((reportCustom: any) => {
      this.selectedValues = reportCustom.headers;
      }, (error: HttpErrorResponse) => {});
  }
  downloadReport(): void{
    if (this.reportName === 'registration') {
      this.filtersForm.headers = this.selectedValues;
    }else{
      this.filtersForm.value.headers = this.selectedValues;
    }
    if (this.reportName === 'registration'){
      this.service.downloadCustomReport(this.filtersForm, {
        sortBy: this.sortBy,
          sortOrder: this.sortOrder
      })
        .subscribe((response: Uuid) => {
          const dialogRef = this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {jobId: response.uuid, showProgress: false},
          });
        }, (error: HttpErrorResponse) => {
          this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
        });
    }else{
      if (this.reportName === 'ofwca_regional' || this.reportName === 'partner_regional' || this.reportName === 'identifiers_regional' ){
        this.service.downloadCustomReportRegional(this.filtersForm.value)
          .subscribe((response: Uuid) => {
            const dialogRef = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
          });
      } else {
        this.service.downloadCustomReport(this.filtersForm.value)
          .subscribe((response: Uuid) => {
            const dialogRef = this.dialog.open(JobResultDialogComponent, {
              disableClose: true,
              width: '500px',
              data: {jobId: response.uuid, showProgress: false},
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
          });
      }
    }
  }
}
